<template>
  <div :class="contentWidth === 'boxed' ? 'container p-0' : null">
    <loading
      id="loading"
      :active="true"
      :is-full-page="true"
      :loader="'bars'"
      :color="'#7367F0'"
    />
    <router-view />
  </div>
</template>

<script>
import useAppConfig from '@core/app-config/useAppConfig'

export default {
  setup() {
    const { contentWidth } = useAppConfig()
    return { contentWidth }
  },
}
</script>
